module.exports = "/cyber/_next/static/images/BannerDesktopFOG-592a78f771c7a0dcc932d13061915e17.jpg";